import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manufacturerRequests: {},
  processing: {},
  profitDistributions: {},
  refreshList: false,
};

const manufacturerSlice = createSlice({
  name: "manufacturer",
  initialState,
  reducers: {
    addManufacturer: (state, action) => {
      const { name, data } = action.payload;
      state[name] = data;
    },
    isRefreshList: (state, action) => {
      state.refreshList = action.payload;
    },
  },
});

export default manufacturerSlice;
export const { addManufacturer, isRefreshList } = manufacturerSlice.actions;
